import { atom } from 'jotai';

/**
 * Whether the mobile bottom-sheet variant of the site-wide login prompt is
 * showing (revamp_2026). The full-screen modal variant uses
 * uiStateAtomLoginModalOpened instead.
 */
export const uiStateAtomLoginPromptSheetOpened = atom(false);
